import { RootState } from '../types'

export const getMainFeedbackSelector = (state: RootState) => state.feedback

